<template>
  <NavigationLayout
    navigationTitle="ギフトコード交換"
    :navigationBarStyle="{
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigationContentStyle="{
      'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
    }"
  >
    <div id="gift_card_list__wrapper" slot="contents">
      <section v-if="!loading">
        <div id="gift_card_list__container">
          <section>
            <ListItem
              title="所持LIVEポイント"
              v-bind:actionText="formatLivePoint(livePoint.total)"
              v-bind:hasLivePoint="true"
            />
          </section>
          <section
            id="gift_card_list__header"
            v-if="giftIssueState === GIFT_CARD_STATE.AVAILABLE"
          >
            <ListSubheader title="ギフトコード" />
            <div
              v-for="(giftCard, index) in giftCards"
              v-on:click="
                onClickGiftCard(
                  giftCard.giftCardId,
                  giftCard.giftCardBrand,
                  giftCard.giftCardLivePoint,
                  $event
                )
              "
              :key="index"
            >
              <ListItem
                v-bind:title="giftCard.giftCardName"
                v-bind:actionText="formatLivePoint(giftCard.giftCardLivePoint)"
                v-bind:hasLivePoint="true"
              />
            </div>
            <section id="gift_card_nothing" v-if="!hasGiftCards">
              <p>有効なギフトコードがありません。</p>
            </section>
          </section>
          <section
            id="gift_card_list2__header"
            v-if="giftIssueState === GIFT_CARD_STATE.NOT_AVAILABLE"
          >
            <ListSubheader title="ギフトコード" />
            <p>
              LIVEポイント集計中のため
              <br />
              交換が可能になるまでお待ち下さい。
            </p>
          </section>
          <section
            id="gift_card_list3__header"
            v-if="giftIssueState === GIFT_CARD_STATE.ALREADY_ISSUE"
          >
            <ListSubheader title="ギフトコード" />
            <p>今月はギフト交換済みです。</p>
          </section>
          <div>
            <div v-bind:style="CautionsStyle">
              <p>＊ギフトコードの交換は月に1回までです。</p>
              <p>
                ＊ギフトコードの交換をする際に216LIVEポイントが手数料として引かれます。
              </p>
              <p>＊ギフトコードの交換をする際に源泉徴収税が控除されます。</p>
              <p>＊ギフトコード交換機能は日本国内でのみご利用可能です。</p>
              <p>＊ギフトコードのご利用は、期限がございます。また期限の延長は致しかねますので、ご了承ください。</p>
              <p>
                ＊本プログラムはREALITY株式会社による提供です。
                <br />
                本プログラムについてのお問い合わせは Amazon
                ではお受けしておりません。
                <br />
                REALITY
                <a
                  href="https://help.le.wrightflyer.net/?action=inquiry_form&app_id=258305124483241"
                >
                  お問い合わせ窓口
                </a>
                よりお願いいたします。
              </p>
              <p>
                ＊Amazon、Amazon.co.jp およびそれらのロゴは Amazon.com,
                Inc.またはその関連会社の商標です。
              </p>
              <div id="caution_google">
                <p>＊Google Playは、Google LLC の商標です。</p>
              </div>
              <p>＊© 2020 iTunes K.K All rights reserved.</p>
            </div>
          </div>
          <GiftCardDialog />
        </div>
      </section>
      <section v-if="loading">
        <div id="gift_card_list_loading__container">Now Loading...</div>
      </section>
    </div>
  </NavigationLayout>
</template>

<script>
import API from '@/utils/API'
import NavigationLayout from '@/components/NavigationLayout'
import ListItem from '@/components/ListItem'
import ListSubheader from '@/components/ListSubheader'
import MypageStyle from '@/styles/mypage'
import GiftCardDialog from '@/components/GiftCardDialog'
import { GIFT_CARD_STATE } from '@/store/modules/components/giftCardDialog'
import { mapActions } from 'vuex'
export default {
  components: {
    NavigationLayout,
    ListItem,
    ListSubheader,
    GiftCardDialog,
  },
  computed: {
    hasGiftCards: function () {
      return this.giftCards.length > 0
    },
  },
  data: function () {
    return {
      loading: true,
      giftIssueState: {},
      livePoint: {},
      giftCards: {},
      giftCardUrl: {},
      CautionsStyle: MypageStyle.Cautions,
      ListItemStyleSectionLast: MypageStyle.ListItemSectionLast,
      GIFT_CARD_STATE: GIFT_CARD_STATE,
    }
  },
  methods: {
    ...mapActions('components/giftCardDialog', [
      'showGiftCardDialog',
      'showGiftCardNoPointDialog',
      'showGiftCardApiErrorDialog',
      'closeGiftCardDialog',
      'selectNoPoint',
      'selectCardBrand',
    ]),
    fetchGiftCardList: async function () {
      try {
        const request = API.Request.giftCardList()
        const response = await API.load(request)
        if (response.livePoint) {
          this.livePoint = response.livePoint
        }
        if (response.giftCards) {
          this.giftCards = response.giftCards
        }
        if (response.status) {
          this.giftIssueState = response.status
        }
      } catch {
        this.showGiftCardApiErrorDialog()
      }
      this.loading = false
    },
    onClickGiftCard(giftCardId, giftCardBrand, giftCardPoint, event) {
      event.target.blur()
      this.selectCardBrand(giftCardBrand)
      if (this.livePoint.total >= giftCardPoint) {
        this.showGiftCardDialog(giftCardId)
      } else {
        this.showGiftCardNoPointDialog()
      }
    },
    formatLivePoint: function (value) {
      if (!isNaN(value)) {
        return value.toLocaleString()
      } else {
        return '-'
      }
    },
  },
  mounted() {
    this.fetchGiftCardList()
  },
}
</script>

<style scoped>
#gift_card_list__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
  background-color: #fafafa;
}

#gift_card_list__container {
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
  padding-bottom: 80px;
}

#gift_card_list__header {
  /*padding: 12px 15px;*/
  text-align: left;
  background-color: #ffffff;
  line-height: 1.5;
  color: #383838;
}
#gift_card_list2__header {
  /*padding: 12px 15px;*/
  text-align: center;
  background-color: #ffffff;
  line-height: 1.5;
  color: #808080;
}

#gift_card_list3__header {
  /*padding: 12px 15px;*/
  text-align: center;
  background-color: #ffffff;
  line-height: 1.5;
  color: #808080;
}

#gift_card_nothing {
  /*padding: 12px 15px;*/
  text-align: center;
  background-color: #ffffff;
  line-height: 1.5;
  color: #808080;
}

#gift_card_list_loading__container {
  text-align: center;
  color: #808080;
  background-color: #ffffff;
  font-size: 12px;
  padding: 12px 15px;
}

#caution_google {
  font-family: Roboto, sans-serif;
}

section {
  margin-top: 20px;
}
</style>
